export default [
  {
    path: '/app/branches',
    name: 'Branches',
    component: () => import('@/views/Branches/Index.vue'),
    meta: {
      pageTitle: 'Şube Yönetimi',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'BRANCHES_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/branches/add',
    name: 'BranchAdd',
    component: () => import('@/views/Branches/Add.vue'),
    meta: {
      pageTitle: 'Şube Yönetimi',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/branches',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'BRANCHES_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/branches/edit/:id',
    name: 'BranchEdit',
    component: () => import('@/views/Branches/Edit.vue'),
    meta: {
      pageTitle: 'Şube Yönetimi',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/branches',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'BRANCHES_EDIT',
      action: 'read',
    },
  },
]
